export const setProperHeight = () => {
  const fields = document.querySelectorAll('.js-horizontal-text');
  const maxHeight = [...fields].map(e => e.offsetHeight).sort((a, b) => b - a)[0];
  [...fields].forEach(e => (e.style.height = `${maxHeight}px`));
};

window.addEventListener('load', () => {
  document.fonts.ready.then(setProperHeight);
});
